<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="ded"><em>For Mike</em><br/>WHO LED ME TO THE SEA</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795325090_epub_ded_r1.vue?7b4ad507